export enum ValidationMode {
    'CREATE' = 'CREATE',
    'UPDATE' = 'UPDATE',
}
